export enum WidgetsPlacement {
  'PINNED' = 'PINNED',
  'FLOATING' = 'FLOATING',
}
